import "./LoadingOverlay.css";

const LoadingOverlay = ({ mensaje = "Cargando..." }) => {
    return (
        <div className="loading-overlay">
            <div className="loading-spinner"></div>
            <p className="loading-text">{mensaje}</p>
        </div>
    );
};

export default LoadingOverlay;
